export default __webpack_public_path__ + "static/media/frame-warmonger.4a1ed064.png";